import React, { useState } from 'react'
import styled from 'styled-components'

interface ISwitchProps {
  /** When set, ToggleIOS is controlled by the parent (display value follows `checked`). */
  checked?: boolean
  defaultChecked?: boolean
  onChange?: (checked: boolean) => void,
  index?: string,
  disabled?: boolean
}




const ToggleIOS: React.FC<ISwitchProps> = ({
  index,
  checked: checkedProp,
  defaultChecked = false,
  onChange ,
  disabled
}) => {
  const isControlled = checkedProp !== undefined
  const [internalChecked, setInternalChecked] = useState(defaultChecked)
  const checked = isControlled ? checkedProp : internalChecked

  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) return
    const newVal = e.target.checked
    if (!isControlled) {
      setInternalChecked(newVal)
    }
    onChange?.(newVal)
  }

  const ref = index ? index : 'ios-switch'
  return (
      <Container>
        <Checkbox
          type="checkbox"
          checked={checked}
          onChange={handleToggle}
          id={ref}
          disabled={disabled}
        />
        <Switch $checked={checked} $disabled={disabled} htmlFor={ref}>
          <Slider $checked={checked} $disabled={disabled} />
        </Switch>
      </Container>
  
  )
}

const Container = styled.div`
  width: 41px;
  height: 21px;
  position: relative;
`

const Checkbox = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
`

interface SwitchProps {
  $checked: boolean
  $disabled?: boolean
}

const Switch = styled.label<SwitchProps>`
  opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};
  width: 100%;
  height: 100%;
  display: block;
  background-color: ${({ $checked }) => ($checked ? '#34C759' : '#e9e9eb')};
  border-radius: 16px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease-out;
`

const Slider = styled.span<SwitchProps>`
  width: 21px;
  height: 21px;
  position: absolute;
  left: ${({ $checked }) =>
    $checked ? 'calc(50% - 21px/2 + 10px)' : 'calc(50% - 21px/2 - 10px)'};
  top: calc(50% - 22px/2);
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.15), 0px 3px 1px rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease-out;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
`
export default ToggleIOS